import React from 'react';
import PropTypes from 'prop-types';
import { ChipGroup, Typography } from '@metarouter-private/mr-mui';

import { ALLOW_ROW_EVENTS } from 'app/components/data-table/buildBubbleClickProps';
import transformPipelineTagsToChips from 'app/shared/components/tags/transformPipelineTagsToChips';

const CHIP_PROPS = { variant: 'soft', color: 'primary' };

export default function TagsCell({ tags }) {
  const chips = transformPipelineTagsToChips(tags);

  if (chips.length === 0) {
    return (
      <Typography component="div" {...ALLOW_ROW_EVENTS}>
        -
      </Typography>
    );
  }

  return (
    <div {...ALLOW_ROW_EVENTS}>
      <ChipGroup
        chips={chips}
        max={2}
        size="small"
        chipMaxWidth={120}
        popoverChipMaxWidth={200}
        ChipProps={CHIP_PROPS}
      />
    </div>
  );
}

TagsCell.propTypes = {
  tags: PropTypes.array,
};
